import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import {
	getBackendErrorMessage,
	isStandardBackendError,
} from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import type { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

// Shared by all four template mutations: a standard backend error becomes its localized
// error-code toast, a `{ error: { message } }` payload its raw message, anything else the
// generic toast. Shared so the boundary narrowing lives in one place, not four.
export const documentTemplateMutationError = (
	error: unknown,
	tDefault: ReturnType<typeof useTranslationDefault>
): void => {
	if (isStandardBackendError(error)) {
		showToastV2({
			state: 'error',
			title: tDefault(`error_codes.${error.error?.code}`),
		});
		return;
	}
	const backendMessage = getBackendErrorMessage(error);
	if (backendMessage !== undefined) {
		showToastV2({ state: 'error', title: backendMessage });
		return;
	}
	showToastV2({
		state: 'error',
		title: tDefault('common.toast.error.message'),
	});
};
